import React from 'react';

const ValidationError = ({isValidating, error}) => {
    if (isValidating === false || !error) {
        return null;
    }

    return <p className="mt-1 text-xs text-red-500">{error}</p>
}

export default ValidationError;